import { setCustomerAnswer } from '@avantia/questionset-model';
import { applyChanges } from '../engineClient/reducers/reducerLibrary';
import { validateAndMaybeMoveSection } from '../engineClient/reducers/questionSetReducerLibrary';
import { evaluateSectionPrerequisites } from '../engineClient/reducers/questionSetTools';
import { HpClientButtonClickActionFunction, HpClientQuestionSetState } from '../engineClient/types';
import { questionIds, sectionIds } from '../types/questionConstants';

interface SetJourneyPhaseProps {
  phase: string;
  targetSection: keyof typeof sectionIds;
}

export function setJourneyPhaseAndNavigate(
  state: HpClientQuestionSetState,
  phase: string,
  targetSectionId: string
): HpClientQuestionSetState {
  const answers = { ...state.answers };
  const currentPhaseAnswer = answers[questionIds.journeyPhase];
  if (currentPhaseAnswer) {
    answers[questionIds.journeyPhase] = { ...currentPhaseAnswer };
  }

  setCustomerAnswer(answers, questionIds.journeyPhase, phase);
  const newState = applyChanges(state, { answers });
  newState.displayState = applyChanges(newState.displayState, {
    sectionsUI: evaluateSectionPrerequisites(newState.displayState, newState, 'none')
  });

  return validateAndMaybeMoveSection({
    buttonAction: 'move-to-section',
    desiredSectionId: targetSectionId,
    state: newState,
    options: { isValidationRequired: false, bypassMoveToSectionCheck: true, raiseNavigationChangedEvent: true }
  });
}

export const setJourneyPhaseButtonClickAction: HpClientButtonClickActionFunction = ({ state, props }) => {
  const { phase, targetSection } = props as unknown as SetJourneyPhaseProps;
  return setJourneyPhaseAndNavigate(state, phase, sectionIds[targetSection]);
};
